/**
 * Hi! Welcome to the Phaneroo Prayer Requests auth store.
 *
 * - All API fetch requests are actually handled inside the `auth.service.js` file.
 * - Every action has a corresponding $axios request that performs validation and request handling.
 * - Tests for this store module are located in './tests/auth.test.js'
 *
 * @todo
 * - Perform data transforms for dashboard UI
 * - Require collect token in $axios instance from session storage
 *   instead of passing it as param.
 * - prefer session storage to store `auth-token`
 * - replace `auth-token` local storage key with env variable
 */

import { $axios } from '../../utils'
import { signupUser, loginUser, resetUserPassword } from '../../services/auth.service'

export default {
  namespaced: true,
  state: {
    user: null,
    userId: localStorage.getItem('auth-userId') || null,
    authToken: localStorage.getItem('auth-token') || null
  },
  getters: {
    user: state => state.user,
    userId: state => state.userId,
    authToken: state => state.authToken,
    isAuthenticated: state => (!!state.authToken && !!state.user)
  },
  mutations: {
    SET_AUTH_USER (state, payload) {
      state.userId = payload.userId
      state.authToken = payload.authToken
      state.user = payload.user
    },
    REMOVE_AUTH_USER (state) {
      state.user = null
      state.authToken = null
      state.userId = null
    }
  },
  actions: {
    /**
     * Logs a user in
     * @param {Object} context Vuex context object
     * @param {{ email: String, password: String }} credentials User's credentials
     * @returns {Promise<String>}
     */
    async login ({ commit }, credentials) {
      const response = await loginUser(credentials)
      const { userId, token } = response.data
      commit('SET_AUTH_USER', {
        userId,
        authToken: token
      })

      localStorage.setItem('auth-token', token)
      localStorage.setItem('auth-userId', userId)
      $axios.defaults.headers.common['Authorization'] = token
    },
    /**
     * Signs a user up
     * @param {Object} context Vuex context object
     * @param {{ email: String, firstName: String, lastName: String, password: String, confirmPassword: String }} credentials User's credentials
     * @returns {Promise<String>}
     */
    async signup (_context, { data }) {
      const response = await signupUser(data)
      const user = response.data
      if (!user) {
        throw new Error('Could not create new account. Please try again')
      }
      return user
    },

    /**
     * Logs a user out
     * @param {Object} context Vuex context object
     */
    logout ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('prayerRequests/RESET_PRAYER_REQUESTS', null, { root: true })
        commit('replies/RESET_REPLIES', null, { root: true })
        commit('REMOVE_AUTH_USER')
        localStorage.removeItem('auth-token')
        localStorage.removeItem('auth-userId')
        $axios.defaults.headers.common['Authorization'] = null
        resolve()
      })
    },

    /**
     * Resets user's password
     * @param {Object} _context store context
     * @param {Object} payload reset password payload
     */
    async resetPassword (_context, payload) {
      const response = await resetUserPassword(payload)
      return response
    }
  }
}
